import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext'; 
import axiosInstance from '../api/axiosInstance'; 
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  // This handles the response from Google
  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    try {
      // Send the Google ID Token to your backend for verification
      const response = await axiosInstance.post('/api/google-login', {
        token: credentialResponse.credential,
      });

      if (response.data.token) {
        login(response.data.token);
        navigate('/home');
      } else {
        setError('Google login failed: Unauthorized account.');
      }
    } catch (err) {
      console.error('Google Auth Error:', err);
      setError('Failed to authenticate with the server via Google.');
    }
  };

  const handleGoogleError = () => {
    setError('Google Sign-In was unsuccessful. Please try again.');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', flexDirection: 'column' }}>
      <div style={{ border: '1px solid #ddd', padding: '40px', borderRadius: '8px', textAlign: 'center', backgroundColor: '#fff', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
        <h2 style={{ marginBottom: '20px' }}>Internal App Login</h2>
        
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap // Optional: shows a small popup for returning users
          />
        </div>

        {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
        
        <p style={{ color: '#666', fontSize: '12px', marginTop: '20px' }}>
          Restricted access. Use your company email to continue.
        </p>
      </div>
    </div>
  );
};

export default Login;